var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 432,
    viewBox: "0 0 107 432",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.039 293.625C440.301 270.793 450.328 247.153 451.292 223.29C451.366 221.423 451.402 219.556 451.402 217.691C451.402 174.104 432.603 144.93 397.728 126.913C393.578 18.7618 338.929 -21 247.044 -21C151.404 -21 51.6734 41.3768 51.6734 159.818C51.6734 160.105 51.6786 160.393 51.6786 160.681C28.4988 179.716 14.456 203.345 14.456 231.423C14.456 255.338 21.3754 279.99 39.7985 303.494C14.4063 321.742 1.25261 340.782 0.115062 360.026C0.0366107 361.368 0 362.709 0 364.051C0 424.456 83.0776 432 209.813 432C336.552 432 458.957 414.589 458.957 354.184C458.957 333.998 448.923 313.078 421.039 293.625Z",
    fill: "#95AFCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightCloud);
export default __webpack_public_path__ + "static/media/right-cloud.bc2c8f7b41a92cceba92017d9e22ec3b.svg";
export { ForwardRef as ReactComponent };